import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative bg-foreground-950 py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end gap-6 mb-12">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-200/20 text-background-100 text-xs font-medium w-fit whitespace-nowrap">
            Collections
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight">
            14 catégories<br className="hidden md:block" /> à découvrir
          </h2>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - Hipobuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Label */}
              <div className="p-3">
                <p className="text-foreground-900 text-sm font-semibold group-hover:text-primary-600 transition-colors whitespace-nowrap truncate">
                  {cat.name}
                </p>
                <p className="text-foreground-500 text-xs mt-0.5 whitespace-nowrap">
                  Voir la collection
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}